
import React, { useState } from "react";
import { motion } from "framer-motion";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted:", formData);
  };

  return (
    <section className="relative min-h-screen bg-[#C8F1F9] px-4 sm:px-6 py-16 sm:py-24 flex items-center justify-center overflow-hidden">

      {/* Decorative Blurs (hidden on very small screens) */}
      <div className="hidden sm:block absolute top-20 left-10 w-72 h-72 bg-[#3498db]/25 rounded-full blur-3xl" />
      <div className="hidden sm:block absolute bottom-20 right-10 w-72 h-72 bg-pink-300/20 rounded-full blur-3xl" />

      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="
          relative w-full max-w-xl sm:max-w-3xl md:max-w-4xl
          bg-white/90 backdrop-blur-2xl
          rounded-2xl sm:rounded-3xl
          shadow-[0_25px_70px_rgba(0,0,0,0.15)]
          p-6 sm:p-10 md:p-14
        "
      >
        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="text-center mb-10 sm:mb-12"
        >
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-[#3498db] mb-3">
            Contact Study Partners
          </h1>
          <p className="text-sm sm:text-base text-gray-600 max-w-xl mx-auto">
            Have a question or need help?
            Our support team is here to guide you throughout your preparation journey.
          </p>
        </motion.div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-6 sm:space-y-8">

          {/* Name */}
          <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }}>
            <label className="block mb-1.5 font-medium text-gray-700 text-sm sm:text-base">
              Full Name
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="
                w-full rounded-lg sm:rounded-xl
                border border-gray-300
                px-4 py-2.5 sm:px-5 sm:py-3
                text-sm sm:text-base
                focus:outline-none focus:ring-2 focus:ring-[#3498db]
              "
            />
          </motion.div>

          {/* Email */}
          <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }}>
            <label className="block mb-1.5 font-medium text-gray-700 text-sm sm:text-base">
              Email Address
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="
                w-full rounded-lg sm:rounded-xl
                border border-gray-300
                px-4 py-2.5 sm:px-5 sm:py-3
                text-sm sm:text-base
                focus:outline-none focus:ring-2 focus:ring-[#3498db]
              "
            />
          </motion.div>

          {/* Subject */}
          <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }}>
            <label className="block mb-1.5 font-medium text-gray-700 text-sm sm:text-base">
              Exams Preparing For
            </label>
            <input
              type="text"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
              className="
                w-full rounded-lg sm:rounded-xl
                border border-gray-300
                px-4 py-2.5 sm:px-5 sm:py-3
                text-sm sm:text-base
                focus:outline-none focus:ring-2 focus:ring-[#3498db]
              "
            />
          </motion.div>

          {/* Message */}
          <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }}>
            <label className="block mb-1.5 font-medium text-gray-700 text-sm sm:text-base">
              Your Message
            </label>
            <textarea
              name="message"
              rows="4"
              value={formData.message}
              onChange={handleChange}
              required
              className="
                w-full rounded-lg sm:rounded-xl
                border border-gray-300
                px-4 py-2.5 sm:px-5 sm:py-3
                text-sm sm:text-base
                focus:outline-none focus:ring-2 focus:ring-[#3498db]
                resize-none
              "
            />
          </motion.div>

          {/* Submit Button */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.3 }}
            className="text-center pt-2 sm:pt-4"
          >
            <button
              type="submit"
              className="
                w-full sm:w-auto
                bg-gradient-to-r from-[#3498db] to-[#5DADE2]
                text-white font-semibold
                px-8 sm:px-12 py-3
                rounded-full
                shadow-lg
                text-sm sm:text-base
                transition-all duration-300
                hover:scale-105
                hover:shadow-[0_20px_50px_rgba(52,152,219,0.6)]
              "
            >
              Send Message
            </button>
          </motion.div>
        </form>
      </motion.div>
    </section>
  );
};

export default Contact;
